import { useAppTranslation } from '@hooks/useAppTranslation';
import { buildReportCreationTemplateCsvContent } from '../utils/csvTemplate.utils';

export const useCsvTemplateDownload = (): {
  downloadTemplate: () => void;
} => {
  const { t, language } = useAppTranslation();

  const downloadTemplate = (): void => {
    if (
      typeof document === 'undefined' ||
      typeof URL === 'undefined' ||
      typeof Blob === 'undefined'
    ) {
      return;
    }

    const csvContent = buildReportCreationTemplateCsvContent(t, language);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const dateStamp = new Date().toISOString().slice(0, 10);

    link.href = url;
    link.download = `report-template-${dateStamp}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return { downloadTemplate };
};
